import React, { CSSProperties, ReactNode } from 'react';
import Message from 'carbon-react/lib/components/message';
import { MessageVariant } from 'carbon-react/lib/components/message/message.component';

import * as styles from './styles.scss';

interface Props {
  children: ReactNode;
  open: boolean;
  variant?: MessageVariant;
  styles?: CSSProperties;
}

export const ToastMessage = ({ children, open, variant = 'neutral', styles: propStyles }: Props) => (
  <div className={styles.messageContainer} style={propStyles}>
    <Message open={open} variant={variant}>
      {children}
    </Message>
  </div>
);
